// ArticleTable.js
import { useState } from "react";
import { toJalali } from "../../utils/moment";
import ViewPostModal from "../viewPostModal";
import { deleteArticle } from "../../api/articleApi";

const ArticleTable = ({
  data,
  setRefresh,
  setLoading,
  setEditData,
  setIsEditing,
}) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedPost, setSelectedPost] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await deleteArticle(deleteId);
      setRefresh((prev) => !prev);
      alert("مقاله با موفقیت حذف شد");
    } catch (error) {
      console.error("Error deleting post:", error);
      alert("خطا در حذف مقاله");
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };

  const handleView = (article) => {
    setSelectedPost(article);
    setShowViewModal(true);
  };

  const handleEdit = (article) => {
    setEditData(article);
    setIsEditing(true);
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-4 mt-4">
      {/* مودال حذف */}
      {showDeleteModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
          <div className="bg-white rounded-xl p-6 max-w-md w-full">
            <h3 className="text-xl font-bold mb-4">حذف مقاله</h3>
            <p className="text-gray-600 mb-6">
              آیا از حذف این مقاله اطمینان دارید؟
            </p>
            <div className="flex gap-3">
              <button
                onClick={handleDelete}
                className="flex-1 bg-red-500 text-white py-2 rounded-lg hover:bg-red-600"
              >
                حذف
              </button>
              <button
                onClick={() => setShowDeleteModal(false)}
                className="flex-1 bg-gray-300 text-gray-700 py-2 rounded-lg hover:bg-gray-400"
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      )}

      {/* مودال نمایش مقاله */}
      {showViewModal && selectedPost && (
        <ViewPostModal
          post={selectedPost}
          onClose={() => {
            setShowViewModal(false);
            setSelectedPost(null);
          }}
        />
      )}

      {/* جدول */}
      <div className="overflow-x-auto">
        <table className="w-full text-right">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3">ردیف</th>
              <th className="px-4 py-3">عنوان</th>
              <th className="px-4 py-3">خلاصه</th>
              <th className="px-4 py-3">تاریخ ایجاد</th>
              <th className="px-4 py-3">نویسنده</th>
              <th className="px-4 py-3">عملیات</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {data.map((article, index) => (
              <tr key={article.id || article._id} className="hover:bg-gray-50">
                <td className="px-4 py-3">{index + 1}</td>
                <td className="px-4 py-3 font-medium">{article.title}</td>
                <td className="px-4 py-3 max-w-md">
                  <div className="truncate">{article.summary}</div>
                </td>
                <td className="px-4 py-3 whitespace-nowrap">
                  {toJalali(article.created_at)}
                </td>
                <td className="px-4 py-3">
                  {article.authorId ? article.authorId.name : "نامشخص"}
                </td>
                <td className="px-4 py-3">
                  <div className="flex gap-2">
                    <button
                      onClick={() => handleView(article)}
                      className="text-blue-600 hover:text-blue-800 transition-colors px-3 py-1 rounded hover:bg-blue-50"
                      title="مشاهده مقاله"
                    >
                      👁️ نمایش
                    </button>
                    <button
                      onClick={() => handleEdit(article)}
                      className="text-green-600 hover:text-green-800 transition-colors px-3 py-1 rounded hover:bg-green-50"
                      title="ویرایش مقاله"
                    >
                      ✏️ ویرایش
                    </button>
                    <button
                      onClick={() => {
                        setDeleteId(article._id);
                        setShowDeleteModal(true);
                      }}
                      className="text-red-600 hover:text-red-800 transition-colors px-3 py-1 rounded hover:bg-red-50"
                      title="حذف مقاله"
                    >
                      🗑️ حذف
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* نمایش تعداد مقالات */}
      <div className="mt-4 text-center text-gray-500 text-sm">
        تعداد کل مقالات: {data.length}
      </div>
    </div>
  );
};

export default ArticleTable;
